
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 92 53"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#_clipPath_DBKJNQ6ncz1fVktbefDVInZnlBu8kyHj)"}},[_c('path',{attrs:{"d":"M2.6 17.5c.6-3.7 1.6-6.7 3.2-8.7 1.4-2.1 3.6-3.7 6.3-4.9 2.7-1.1 6.5-1.7 11.3-1.7 5 0 8.9.6 11.6 1.6 2.9 1.1 5.1 2.7 6.6 5 1.6 2.2 2.5 4.6 2.5 7.5 0 2.8-.9 5.7-2.8 8.3-1.8 2.7-5.1 5.6-10 8.9-2.9 1.8-4.7 3.1-5.7 3.8-1 .7-2.2 1.7-3.5 2.9h23.3V1.9c4.3.6 8.4 2 12.1 4.6q2.9 1.9 9.6 9.2c1.2 1.4 2.5 3 3.8 4.9 2 3 3.4 5 4.3 5.8.8 1 1.8 2.3 3.1 3.6V1.9h12.1v49.2c-4.5-.4-8.5-2-12.4-4.6-2.7-1.9-6-4.9-9.4-9.2-1.3-1.4-2.5-3-3.8-4.9-2.1-3-6.3-8-7.5-9.4v28.1H1.6c.5-3.9 2-7.6 4.5-11.2 2.4-3.4 7.2-7.6 14-12.3 4.2-2.9 6.9-5.2 8.1-6.6 1.1-1.6 1.7-3 1.7-4.3 0-1.5-.6-2.7-1.7-3.7-1.2-1.2-2.6-1.6-4.5-1.6-1.7 0-3.3.6-4.4 1.6-1.2 1.1-1.7 1.8-2.2 4.5H2.6z","fill":"none","vector-effect":"non-scaling-stroke"}})])])
          )
        }
      }
    